

const ContentBackground = props => {
    return (
        <div className={`card text-color-default ${props.className}`}>
            <div className="card-body">
                { props.children }
            </div>
        </div>
    );
}
  
export default ContentBackground;